import {
  fetch
} from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 列表列表
 */
export function getSpendingList(data) {
  return fetch({
    url: '/financial/spending/getSpendingList',
    method: 'GET',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Spending/index.js